import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlComponent } from '../base-control.component';

@Component({
  selector: 'boi-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DateTimePickerComponent,
      multi: true
    }
  ],
  exportAs: 'boi-date-time-picker'
})
export class DateTimePickerComponent extends BaseControlComponent {
  @Input() public min: Date;
  @Input() public max: Date;
  @Input() public format: string;
  @Input() public placeholder: string;
}
